import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import sanityClient from "../../client.js";
import foto from "../../assets/image/together.jpg";

function Fpartone() {
  const [allPostsData, setAllPosts] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "contact"]{
        title,
        body,
        slug
    }`,
      )
      .then((data) => setAllPosts(data))
      .catch(console.error);

    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);
  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  if (!loading) {
    return <div></div>;
  }

  return (
    <div ref={ref} className={`box ${inView ? "actives" : ""}`}>
      {allPostsData &&
        allPostsData.map((contact, index) => (
          //<Link to={"/" + post.slug.current} key={post.slug.current}>
          <span key={index}>
            {
              //  <h2 className="tsm:text-3xl text-2xl font-medium title-font text-gray-900 mb-4">
              // {contact.title}
              // </h2>
              // <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-500s">
              //  {contact.body} </p>
            }
            <div class="flex flex-col md:flex-row items-center gap-8">
              <div class="w-full md:w-1/2">
                <img
                  className=" w-full h-[27rem] md:h-[38rem] object-cover object-[25%_36%]"
                  src={foto}
                />
              </div>

              <div class="w-full md:w-1/2 flex flex-col justify-center items-center text-center">
                <h2 class="text-3xl font-medium title-font text-gray-900 mb-4">
                  {contact.title}
                </h2>

                <p class="text-base leading-relaxed text-gray-500">
                  {contact.body}
                </p>
              </div>
            </div>
          </span>

          // </Link>
        ))}

      <div className="flex mt-6 justify-center">
        <div className="w-16 h-1 rounded-full bg-kasiagreen-default inline-flex hidden"></div>
      </div>
    </div>
  );
}
export default Fpartone;
